var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-padding": "" } },
        [
          _c(
            "w-breadcrumb",
            { attrs: { crumbs: _vm.path } },
            [
              _c("w-spacer"),
              _vm.$wf.isMdUp
                ? _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-card",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-card-title", [
                            _vm._v(_vm._s(_vm.$ct("journal-settings"))),
                          ]),
                          _c(
                            "w-list",
                            _vm._l(_vm.journalIds, function (id) {
                              return _c(
                                "w-list-item",
                                {
                                  key: id,
                                  on: {
                                    click: function ($event) {
                                      return _vm.editJournalName(id)
                                    },
                                  },
                                },
                                [
                                  _c("w-list-item-text", [
                                    _vm._v(
                                      _vm._s(id) +
                                        ": " +
                                        _vm._s(_vm.value.getJournalName(id))
                                    ),
                                  ]),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-modal",
            { attrs: { value: _vm.toEditJournalId != 0 } },
            [
              _vm.toEditJournalId != 0
                ? _c("app-journal-config-edit", {
                    attrs: {
                      "journal-id": _vm.toEditJournalId,
                      value: _vm.value.getJournalConfig(_vm.toEditJournalId),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setJournalConfig(_vm.toEditJournalId, $event)
                      },
                      close: function ($event) {
                        _vm.toEditJournalId = 0
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }